
import { Component, OnInit, Inject, ElementRef, NgZone, ViewChild } from '@angular/core';
import { DealershipService } from '../services/dealership.service';
import { DealershipOverview, ColourScheme, BrandedStyleDetails } from '../models/dealership.model';
import { CustomerServiceIdentity } from '../services/customer.service';
// import {  } from 'googlemaps';

import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
    selector: 'edit-dealership-branding-modal',
    templateUrl: './edit-dealership-branding-modal.component.html',
    styleUrls: ['./edit-dealership-branding-modal.component.scss']
})
export class EditDealershipBrandingModalComponent implements OnInit {
    logoHasChanged: boolean = false;
    styleId: number;
    brandName: string = '';
    logoutRedirectUrl: string = '';
    identityServerUrl: string = '';
    undercarriageUrl: string = '';
    undercarriageUiUrl: string = '';
    getUrl: string = '';
    getUiUrl: string = '';
    imageUrl: string = '';
    dealershipId: number = 0;
    dealershipName: string = '';
    selectedColourSchemeId: number = 0;
    safeLogoUrl: SafeResourceUrl;

    ImageFile:File;
    ImageName:string;
    colourSchemes: ColourScheme[] = [];

    savingBrand: boolean = false;
    loadingData: boolean = true;

    constructor(public dialogRef: MatDialogRef<EditDealershipBrandingModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private _dealershipService: DealershipService, private _customerService: CustomerServiceIdentity,
        private ngZone: NgZone, public snackBar: MatSnackBar, private _notifications: NotificationsService, private sanitizer: DomSanitizer) { }

    ngOnInit() {
        if (this.data != null) {
            this.styleId = this.data.styleId;
        }

        this._dealershipService.getAllColourSchemes().subscribe(response => {
            this.colourSchemes = response;
            this.loadingData = false;
            this.loadStyleData();
        });
    }

    loadStyleData() {
        this._dealershipService.getBrandedStyleDetails(this.styleId).subscribe(response => {
            this.brandName = response.Name;
            this.selectedColourSchemeId = response.ColourSchemeId;
            this.logoutRedirectUrl = response.LogoutRedirectUrl;
            this.dealershipId = response.DealershipId;
            this.getUiUrl = response.GetUiUrl;
            this.getUrl = response.GetUrl;
            this.identityServerUrl = response.IdentityServerUrl;
            this.undercarriageUiUrl = response.UndercarriageUiUrl;
            this.undercarriageUrl = response.UndercarriageUrl;
            this.logoutRedirectUrl = response.LogoutRedirectUrl;
            this.safeLogoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + response.Logo);
            this.imageUrl = response.Logo;
            this.loadingData = false;
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSelectImage(event) {
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();

            reader.readAsDataURL(event.target.files[0]); // read file as data url
            this.ImageFile=event.target.files[0];
          reader.onload = (event: any) => { // called once readAsDataURL is completed
                this.imageUrl = event.target["result"];
                this.ImageName=this.ImageFile.name;
            }
            this.logoHasChanged = true;
        }
    }

    updateBrandedStyle() {
        if (this.savingBrand)
            return;
        if (this.brandName.length < 1 || this.selectedColourSchemeId == 0 || this.logoutRedirectUrl.length < 1 || this.identityServerUrl.length < 1 || this.undercarriageUrl.length < 1
            || this.undercarriageUiUrl.length < 1 || this.getUiUrl.length < 1 || this.getUrl.length < 1 || this.imageUrl.length < 1) {
            this.snackBar.open('Please fill in all required fields (*)', '', {
                duration: 1500,
            });
            return;
        }
        this.savingBrand = true;
        let logoUrl2 = this.logoHasChanged ? this.imageUrl : '';
        let style: BrandedStyleDetails = {
            ColourSchemeId: this.selectedColourSchemeId,
            DealershipId: this.dealershipId,
            GetUiUrl: this.getUiUrl,
            GetUrl: this.getUrl,
            IdentityServerUrl: this.identityServerUrl,
            Id: this.styleId,
            Logo: logoUrl2,
            LogoutRedirectUrl: this.logoutRedirectUrl,
            Name: this.brandName,
            UndercarriageUiUrl: this.undercarriageUiUrl,
            UndercarriageUrl: this.undercarriageUrl,
            FileName:this.ImageName
        }

        this._dealershipService.updateBrandedStyle(style).subscribe(response => {
            if (response.m_Item1) {
                this._notifications.success('Updated Successfully', 'The branded style has been updated. ');
                this.dialogRef.close(true);
            } else {
                this._notifications.error('Failed', response.m_Item2);
            }
        });
    }
}

interface FileReaderEventTarget extends EventTarget {
    result: string
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}
